import { RootState } from '../../store/rootReducer';

export const getComment = (state: RootState) => state.comment;
